import { render, staticRenderFns } from "./tender_field.vue?vue&type=template&id=24efa418&scoped=true&"
import script from "./tender_field.vue?vue&type=script&lang=js&"
export * from "./tender_field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24efa418",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24efa418')) {
      api.createRecord('24efa418', component.options)
    } else {
      api.reload('24efa418', component.options)
    }
    module.hot.accept("./tender_field.vue?vue&type=template&id=24efa418&scoped=true&", function () {
      api.rerender('24efa418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/tender/tender_field.vue"
export default component.exports